const skillsList = ['PDR', 'R&I', 'Paint', 'Detail', 'Mechanical', 'Diagnostics', 'Overspray'];

export default skillsList;
